import {


  GET_JUNIOR_HANDLING_RESULT_FILES,
  GET_JUNIOR_HANDLING_RESULT_FILES_SUCCESS,
  GET_JUNIOR_HANDLING_RESULT_FILES_FAIL,
  ADD_JUNIOR_HANDLING_EVENT_FILE,
  ADD_JUNIOR_HANDLING_EVENT_FILE_FAILURE,
  ADD_JUNIOR_HANDLING_EVENT_FILE_SUCCESS,
  DEL_JUNIOR_HANDLING_DISPLAY_EVENT_FILE,
  DEL_JUNIOR_HANDLING_DISPLAY_EVENT_FILE_SUCCESS,
  DEL_JUNIOR_HANDLING_DISPLAY_EVENT_FILE_FAILURE,
  GET_JUNIOR_HANDLING_FILE_RESULTS,
  GET_JUNIOR_HANDLING_FILE_RESULTS_SUCCESS,
  GET_JUNIOR_HANDLING_FILE_RESULTS_FAIL,
  GET_JUNIOR_EVENT_ATTENDEE_RESULTS,
  GET_JUNIOR_EVENT_ATTENDEE_RESULTS_SUCCESS,
  GET_JUNIOR_EVENT_ATTENDEE_RESULTS_FAIL,
} from "./actionTypes";

const initialState = {
  juniorEventList: [],
  attendeeList: [],
  dogPoints: [],

  rankingList: [],
  overallRankingList: [],
  loading: false,
  loadingGetEventAttendee: false,
  loadingGetEventResult: false,
  loadingGetOverallResult: false,
  loadingGetClubWiseRanking: false,
  clubWiseResponse: [],
  loadingGetDogResult: false,

  error: {
    message: "",
    code: "",
  },
  addJuniorHandlingEventResponse: {},
  loadingAddJuniorHandlingEvent: false,
  calculateResultResponse: {},
  loadingCalculateResult: false,

  fileEventList: [],
  loadingGetFileEventList: false,

  publicRankingList: [],
  loadingGetEventPublicResult: false,

  delFileResponse: {},
  loadingDelFile: false,

  calculateOverallResultRespone: {},
  loadingOverallResult: false,

  fileResultRes: [],
  loadingGetFileResults: false,
  filterOptions :[],
  count :0,

  jrHandleAttendee :[],
  loadingJrHandleAttendee :false


};

const JuniorHandlingDisplayReducer = (state = initialState, action) => {


  switch (action.type) {

    // junior handling file result 
    case GET_JUNIOR_HANDLING_FILE_RESULTS:
      state = {
        ...state,
        loadingGetFileResults: true
      };
      break;
    case GET_JUNIOR_HANDLING_FILE_RESULTS_SUCCESS:
      state = {
        ...state,
        fileResultRes: action.payload.eventFileList,
         count :action.payload.count,
        filterOptions :action.payload.results,
        loadingGetFileResults: false
      };
      break;
    case GET_JUNIOR_HANDLING_FILE_RESULTS_FAIL:
      state = {
        ...state,
        error: {
          message: action.payload.data.message,
        },
        loadingGetClubWiseRanking: false,
      };
      break;

    case ADD_JUNIOR_HANDLING_EVENT_FILE:
      state = {
        ...state,
        loadingAddJuniorHandlingEvent: true
      };
      break;
    case ADD_JUNIOR_HANDLING_EVENT_FILE_SUCCESS:
      state = {
        ...state,
        addJuniorHandlingEventResponse: action.payload,
        loadingAddJuniorHandlingEvent: false
      };

      break;
    case ADD_JUNIOR_HANDLING_EVENT_FILE_FAILURE:
      state = {
        ...state,
        error: {
          message: action.payload.data.message,
        },
        loadingAddLocation: false,
      };
      break;

    case GET_JUNIOR_HANDLING_RESULT_FILES:

      state = {
        ...state,
        loading: true
      };
      break;
    case GET_JUNIOR_HANDLING_RESULT_FILES_SUCCESS:

      state = {
        ...state,
        juniorEventList: action.payload.eventFileList,
        loading: false
      };
      break;
    case GET_JUNIOR_HANDLING_RESULT_FILES_FAIL:
      state = {
        ...state,
        error: {
          message: action.payload.data.message,
        },
        loading: false,
      };
      break;

    case GET_JUNIOR_EVENT_ATTENDEE_RESULTS:
      state = {
        ...state,
        loadingJrHandleAttendee: true
      };
      break;
    case GET_JUNIOR_EVENT_ATTENDEE_RESULTS_SUCCESS:
      state = {
        ...state,
        jrHandleAttendee: action.payload,
        loadingJrHandleAttendee: false
      };
      break;
    case GET_JUNIOR_EVENT_ATTENDEE_RESULTS_FAIL:
      state = {
        ...state,
        error: {
          message: action.payload.data.message,
        },
        loadingJrHandleAttendee: false,
      };
      break;

    case DEL_JUNIOR_HANDLING_DISPLAY_EVENT_FILE:
      state = {
        ...state,
        loadingDelFile: true
      };
      break;
    case DEL_JUNIOR_HANDLING_DISPLAY_EVENT_FILE_SUCCESS:
      state = {
        ...state,
        delFileResponse: action.payload,
        loadingDelFile: false
      };

      break;
    case DEL_JUNIOR_HANDLING_DISPLAY_EVENT_FILE_FAILURE:
      state = {
        ...state,
        error: {
          message: action.payload.data.message,
        },
        loadingDelFile: false,
      };
      break;
    default:
      state = {
        ...state
      };
      break;
  }
  return state;
};

export default JuniorHandlingDisplayReducer;